export default __webpack_public_path__ + "static/media/icon_7_1.5a9eac0b.svg";